import { apiError } from "store/actions"
import React, { useEffect, useState } from "react"
import Select from "react-select"

import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { mapDataForDropDown, getInitialStateForUpdate } from "helpers/helpers"
import FieldValidation from "../../../components/Common/FieldValidation"
import { getAllOperatorProductsCall } from "../../../helpers/repository"
//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAllProducts } from "store/products/actions"
import { getAllProductChannels } from "store/channels/actions"
import { getAllProductCategories } from "store/categories/actions"
import { getAllSuppliers } from "store/suppliers/actions"
import {
  createOperatorProduct,
  updateOperatorProduct,
} from "store/operatorProducts/actions"
import {sitename} from "../../../constants/constants";

const Edit = props => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllProductChannels())
    dispatch(getAllProducts())
    dispatch(getAllProductCategories())
    dispatch(getAllSuppliers())
    // dispatch(getAllOperatorProducts())
    getDefaultState()
    dispatch(apiError(""))
  }, [])
  const urlParams = new URLSearchParams(props.location.search)

  const Products = useSelector(state => state?.products?.Index ?? [])
  const Channels = useSelector(state => state?.productChannels?.Index ?? [])
  const Categories = useSelector(state => state?.productCategories?.Index ?? [])
  const Suppliers = useSelector(state => state?.suppliers?.Index ?? [])
  const OperatorProducts = useSelector(
    state => state?.operatorProducts?.Index ?? []
  )
  const formErrors = useSelector(state => state?.CommonState)

  const [channel, setChannel] = useState({})
  const [category, setCategory] = useState("")
  const [product, setProduct] = useState("")
  const [supplier, setSupplier] = useState("")
  const [isActive, setIsActive] = useState(false)
  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      product_channel_id: channel?.value,
      product_category_id: category?.value,
      product_id: product?.value,
      supplier_id: supplier?.value,
      operator_product_id: +urlParams.get("id"),
      is_active: isActive ? 1 : 0,
    }
    dispatch(updateOperatorProduct(data, props.history, "operator-products"))
  }

  const getDefaultState = () => {
    getAllOperatorProductsCall().then(res => {
      let obj = res.data.data.operator_products.filter(
        op => op["id"] == urlParams.get("id")
      )
      obj = obj.length > 0 ? obj[0] : {}
      setChannel({
        label: obj?.product_channel?.name,
        value: obj?.product_channel_id,
      })
      setCategory({
        label: obj?.product_category?.name,
        value: obj?.product_category_id,
      })
      setProduct({
        label: obj?.product?.name,
        value: obj?.product_id,
      })
      setSupplier({
        label: obj?.supplier?.name,
        value: obj?.supplier_id,
      })
      setIsActive(obj?.is_active)
    })
  }
  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Operator Products" breadcrumbItem="Edit" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              product details
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Product Channel
                  </Label>
                  <Col sm={5}>
                    <Select
                      maxMenuHeight={150}
                      onChange={channel => {
                        removeError("product_channel_id")

                        setChannel({
                          label: channel?.label,
                          value: channel?.id,
                        })
                      }}
                      classNamePrefix="select2-selection"
                      options={mapDataForDropDown(Channels)}
                      value={channel}
                    />
                    {formErrors?.product_channel_id ? (
                      <FieldValidation
                        errorMessage={formErrors?.product_channel_id}
                      />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Category
                  </Label>
                  <Col sm={5}>
                    <Select
                      onChange={category => {
                        removeError("product_category_id")

                        setCategory({
                          label: category?.label,
                          value: category?.id,
                        })
                      }}
                      classNamePrefix="select2-selection"
                      options={mapDataForDropDown(Categories)}
                      value={category}
                      maxMenuHeight={150}
                    />
                    {formErrors?.product_category_id ? (
                      <FieldValidation
                        errorMessage={formErrors?.product_category_id}
                      />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Supplier
                  </Label>
                  <Col sm={5}>
                    <Select
                      onChange={supplier => {
                        removeError("supplier_id")

                        setSupplier({
                          label: supplier?.label,
                          value: supplier?.id,
                        })
                      }}
                      options={mapDataForDropDown(Suppliers)}
                      classNamePrefix="select2-selection"
                      value={supplier}
                      maxMenuHeight={150}
                    />
                    {formErrors?.supplier_id ? (
                      <FieldValidation errorMessage={formErrors?.supplier_id} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Product
                  </Label>
                  <Col sm={5}>
                    <Select
                      onChange={product => {
                        removeError("product_id")

                        setProduct({
                          label: product?.label,
                          value: product?.id,
                        })
                      }}
                      options={mapDataForDropDown(Products)}
                      classNamePrefix="select2-selection"
                      value={product}
                      maxMenuHeight={150}
                    />
                    {formErrors?.product_id ? (
                      <FieldValidation errorMessage={formErrors?.product_id} />
                    ) : null}
                  </Col>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="defaultCheck1"
                    onChange={() => setIsActive(!isActive)}
                    checked={isActive}
                  />
                  <label className="form-check-label" htmlFor="defaultCheck1">
                    Is Active?
                  </label>
                </div>
                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/operator-products")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const EditOperatorProduct = withRouter(Edit)
